export default __webpack_public_path__ + "static/media/forbidden.755faca7.png";